module.exports = __webpack_public_path__ + "img/profileEdit.b3dae317.svg";